export function getQuizTeamsRoutes() {
  return [
    {
      path: "/quiz-teams",
      name: "quiz-teams",
      component: () => import(/* webpackChunkName: quiz-team-old-backend */ "./components/QuizTeamsOld.vue"),
    },
  ]
}
